import {
  fetchGuideFavorite,
  Guide,
  guidesCountQueryOptions,
  PaginatedQuery,
} from '@blesk-frontend/api';
import {Updater, useMutation, useQueryClient} from '@tanstack/react-query';

type GuideUpdaterData = Guide | PaginatedQuery<Guide> | undefined;

/**
 * This mutation hook is used to update the Guide.
 */
export const useGuideFavoriteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchGuideFavorite,
    onMutate(guideId) {
      queryClient.refetchQueries({queryKey: guidesCountQueryOptions().queryKey});

      const updater: Updater<GuideUpdaterData, GuideUpdaterData> = (old) => {
        if (!old) {
          return old;
        }
        if ('pagination' in old) {
          return {
            ...old,
            data: old.data.map((guide) => {
              return guide.id === guideId
                ? {...guide, _count: {favorite: guide._count.favorite === 0 ? 1 : 0}}
                : guide;
            }),
          };
        }
        if ('id' in old) {
          return {...old, _count: {favorite: old._count.favorite === 0 ? 1 : 0}};
        }
      };

      queryClient.setQueriesData<GuideUpdaterData>({queryKey: ['guides']}, updater);
    },
  });
};
